<!-- See component TS for usage. Filter css class is important to functionality -->
@if (isCheckListFilter(filter)) {
    @if (filter.type === 'ratingChecklist') {
        <!--Rating Checklist-->
        <div class="filter">
            @for (option of filter.options; track option.value) {
                <div class="ui checkbox filter">
                    <input
                        type="checkbox"
                        class="filter"
                        [checked]="filter.isActive(option)"
                        (change)="filter.toggle(option)"
                        [id]="option.label"
                        [value]="option.value"
                    />

                    <label class="filter" [attr.for]="option.label">
                        <div
                            class="ui static tiny star rating"
                            deprecated-ui-rating
                            status="disabled"
                            [attr.data-rating]="option.label"
                            [attr.data-max-rating]="option.label"
                        ></div>
                    </label>
                </div>
            }
        </div>
    } @else {
        <!--Checklist-->
        <div class="filter">
            @for (option of filter.options; track option.value) {
                <div class="filter" (click)="filter.toggle(option)">
                    <mat-checkbox type="checkbox" class="filter" [checked]="filter.isActive(option)">{{
                        option.label | translate
                    }}</mat-checkbox>
                </div>
            }
        </div>
    }
}

<!--Date Range-->
@if (isDateRangeFilter(filter)) {
    <div class="filter">
        <ui-inline-date-picker
            (dateRangesChange)="filter.setDateRange($event)"
            [startDate]="filter.startDate"
            [endDate]="filter.endDate"
        ></ui-inline-date-picker>
    </div>
}

@if (isYearFilter(filter)) {
    <!--Year-->
    <div class="filter flex">
        <div class="app-grid">
            <mat-form-field class="columns-12">
                <mat-label appRemoveAriaOwns>{{ 'table.components.columnFilter.year' | translate }}</mat-label>
                <mat-select
                    [ngModel]="filter.selectedYear"
                    (ngModelChange)="filter.setYear($event)"
                    [name]="'year-filter-' + context"
                    placeholder="{{ 'table.components.columnFilter.selectYear' | translate }}"
                >
                    @for (option of filter.options; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>
}

@if (isSelectFilter(filter) || isRadioButtonFilter(filter)) {
    <mat-radio-group class="vertical" (change)="filter.changeValue($event.value)">
        <!--A "none" option is provided for convenience for users to un-select a filter since radio buttons can't be deselected-->
        @if (filter.nullable) {
            <mat-radio-button [value]="{ value: null }" [checked]="filter.selected === null">
                <span class="font-secondary">{{ 'none' | translate }}</span>
            </mat-radio-button>
        }
        @for (option of filter.options; track option.value) {
            <mat-radio-button [value]="option" [checked]="filter.selected === option">
                <span class="no-wrap">{{ option.label | translate }}</span>
            </mat-radio-button>
        }
    </mat-radio-group>
}
